import { PlayCircle } from 'lucide-react';
import SectionHeading from './SectionHeading';

// ✅ Solo importamos el video que sabemos que existe
import actionVideo from '@/assets/videos/action-video.mp4';

const ActionVideo = () => {
  return (
    <section className="bg-[#0A2540] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-[.7fr_1.3fr] lg:px-8">
        {/* Contenido textual */}
        <div>
          <SectionHeading
            light
            eyebrow="Clean Work en acción"
            title="CONOCE NUESTRO TRABAJO"
            text="La limpieza profesional requiere organización, personal capacitado y las herramientas adecuadas. Aquí mostramos el trabajo real realizado por CLEAN WORK."
          />
          <PlayCircle className="mt-8 text-[#94cf1c]" size={44} />
        </div>

        {/* Video */}
        <div className="overflow-hidden rounded-lg border border-white/10 bg-black shadow-2xl">
          <div className="aspect-video">
            <video
              src={actionVideo}
              controls
              loop
              autoPlay
              muted
              playsInline
              preload="metadata"
              aria-label="Video de Clean Work en acción"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActionVideo;